export default [
  {
    path: 'certificates',
    name: 'certificates',
    component: () => import('@/views/certificates/Certificates.vue'),
    meta: { registerNavFromMenu: true }
  },
  {
    path: 'certificates/:idCliente/:serial/:tipoCertificado/details',
    name: 'certificates/detail',
    component: () => import('@/views/certificates/Certificate.vue'),
    meta: { secondaryMenu: 'certificates', registerNavFromMenu: false }
  },
  {
    path: 'certificates/:idCliente/:serial/:tipoCertificado/companies',
    name: 'certificates/companies',
    component: () => import('@/views/certificates/Companies.vue'),
    meta: { secondaryMenu: 'certificates', registerNavFromMenu: false }
  },
  {
    path: 'certificates/:idCliente/:serial/:tipoCertificado/historical',
    name: 'certificates/historical',
    component: () => import('@/views/historical/CertificateHistorical.vue'),
    meta: { secondaryMenu: 'certificates', registerNavFromMenu: false }
  },
  {
    path: 'certificates/:idCliente/:serial/:tipoCertificado/replace',
    name: 'certificates/replace',
    component: () => import('@/views/certificates/ReplaceCertificate.vue'),
    meta: { secondaryMenu: 'replacecertificate', registerNavFromMenu: false }
  }
]
